import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '@processo/services/token.service';
import { StateService } from '@processo/shared/state/state.service';
import { logAuthEvent } from '@processo/core/helpers/auth-diag.util';

export const authGuard: CanActivateFn = () => {
  const state = inject(StateService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  if (state.isUserLoggedIn().loggedIn) {
    return true;
  } else {
    const currentUrl = (typeof window !== 'undefined' && window.location)
      ? `${window.location.pathname}${window.location.search}`
      : '/';
    logAuthEvent('authguard-logout', {
      url: currentUrl.slice(0, 200),
      hadRefreshToken: !!tokenService.getRefreshToken(),
    });
    state.clearState();
    tokenService.clearTokens();
    
    router.navigate(['/login'], {
      queryParams: {
        redirect: currentUrl,
      },
    });
    return false;
  }
};
